export default "/images/vendor/flag-icon-css/flags/4x3/az.svg?d4faca473814e47b3f03fd7c83e72ad1";